<template>
    <div class="spinner" :class="color">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</template>

<script lang="ts">
    import { Component, Mixins } from 'vue-property-decorator';
    import { CoreThemeMixin } from '@/common/mixins';

    @Component({})
    export default class Spinner extends Mixins(CoreThemeMixin) {}
</script>

<style lang="less" scoped>
    .spinner-color-mixin(@color) {
        .bounce1,
        .bounce2,
        .bounce3 {
            background-color: @color;
        }
    }
    .spinner {
        margin: 50px auto;
        width: 70px;
        text-align: center;

        > div {
            width: 10px;
            height: 10px;
            margin: 0 2px;
            background-color: #8a9cac;

            border-radius: 100%;
            display: inline-block;
            animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        }

        .bounce1 {
            animation-delay: -0.32s;
        }

        .bounce2 {
            animation-delay: -0.16s;
        }
        &.success {
            .spinner-color-mixin(@success-color);
        }
        &.info {
            .spinner-color-mixin(@info-color);
        }
        &.warning {
            .spinner-color-mixin(@warning-color);
        }
        &.danger {
            .spinner-color-mixin(@danger-color);
        }
        &.primary {
            .spinner-color-mixin(@primary-color);
        }
        &.branding {
            .spinner-color-mixin(@branding-color);
        }
        &.dark {
            .spinner-color-mixin(@dark-color);
        }
        &.light {
            .spinner-color-mixin(@bright-color);
        }
    }

    @keyframes sk-bouncedelay {
        0%,
        80%,
        100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1);
        }
    }
</style>
